import { Badge } from '@elsapiens/ui'

import type { BadgeProps } from '@elsapiens/ui'

type BadgeVariant = NonNullable<BadgeProps['variant']>

export const TIER_BADGE_VARIANT: Record<string, BadgeVariant> = {
  a: 'success',
  b: 'default',
  c: 'warning',
  d: 'outline',
  e: 'error',
}

const TIER_LABEL: Record<string, string> = {
  a: 'Excellent',
  b: 'Great',
  c: 'Good',
  d: 'Fair',
  e: 'Poor',
}

export function TierBadge({ tier }: { tier: string }): JSX.Element {
  return (
    <Badge size="sm" variant={TIER_BADGE_VARIANT[tier] ?? 'secondary'}>
      {TIER_LABEL[tier] ?? tier}
    </Badge>
  )
}
